import { createReducer, on } from "@ngrx/store";
import {
  cargaAcuerdos,
  resetAcuerdos,
  cargaHistorico,
  updateTipoAcuerdo,
  expandAcuerdo,
  cargaAcuerdosSuccess,
  resetAcuerdosByTipo,
  cargarAcuerdosEditados,
  nuevoAcuerdoMRB,
  loadResponsablesSuccess,
  cancelarAcuerdoMRB,
  nuevoAcuerdoSuccess,
} from "./actions";
import { iUsuario, mUsuario } from "../../usuario/usuario.interface";
import {
  IAcuerdos,
  IStateAcuerdo,
  nuevoAcuerdo,
} from "../../interfaces/acuerdos";

export const initialState: IAcuerdos = IStateAcuerdo;

export const acuerdosMrbReducer = createReducer(
  initialState,
  on(cargaAcuerdosSuccess, (state, payload) => {
    return {
      ...state,
      acuerdos: payload.acuerdos,
      acuerdoActual: payload.acuerdoActual,
      tipoAcuerdo: payload.tipoAcuerdo,
      historico: payload.historico,
    };
  }),

  on(updateTipoAcuerdo, (state, { tipoAcuerdo }) => {
    return {
      ...state,
      tipoAcuerdo: tipoAcuerdo,
    };
  }),
  on(expandAcuerdo, (state, { idAcuerdo }) => {
    return {
      ...state,
      acuerdos: state.acuerdos.map((acuerdo) => ({
        ...acuerdo,
        expanded: acuerdo.idFE === idAcuerdo ? !acuerdo.expanded : false,
      })),
      acuerdoActual: state.acuerdoActual.map((acuerdo) => ({
        ...acuerdo,
        expanded: acuerdo.idFE === idAcuerdo ? !acuerdo.expanded : false,
      })),
      historico: state.historico.map((acuerdo) => ({
        ...acuerdo,
        expanded: acuerdo.idFE === idAcuerdo ? !acuerdo.expanded : false,
      })),
      tipoAcuerdo: state.tipoAcuerdo,
    };
  }),

  // on(updateFechaAcuerdo, (state, { fecha, acuerdo }) => {
  //   return {
  //     ...state,
  //     acuerdoActual: state.acuerdoActual.map((_acuerdo, index) =>
  //       acuerdo.idFE === _acuerdo.idFE
  //         ? { ...acuerdo, fechaAcuerdo: fecha }
  //         : _acuerdo
  //     ),
  //   };
  // }),

  on(resetAcuerdosByTipo, (state, { tipoAcuerdo }) => {
    switch (tipoAcuerdo) {
      case 1:
        return {
          ...state,
          acuerdoActual: state.acuerdoActual.map((acuerdo) => ({
            ...acuerdo,
            expanded: false,
          })),
        };

      case 2:
        return {
          ...state,
          acuerdos: state.acuerdos.map((acuerdo) => ({
            ...acuerdo,
            expanded: false,
          })),
        };

      case 3:
        return {
          ...state,
          historico: state.historico.map((acuerdo) => ({
            ...acuerdo,
            expanded: false,
          })),
        };

      default:
        return {
          ...state,
          acuerdoActual: state.acuerdoActual.map((acuerdo) => ({
            ...acuerdo,
            expanded: false,
          })),
          acuerdos: state.acuerdos.map((acuerdo) => ({
            ...acuerdo,
            expanded: false,
          })),
          historico: state.historico.map((acuerdo) => ({
            ...acuerdo,
            expanded: false,
          })),
        };
    }
  }),

  on(cargaHistorico, (state, { historico }) => {
    return {
      ...state,
      historico,
    };
  }),
  on(resetAcuerdos, (state) => {
    return {
      ...state,
      acuerdoActual: state.acuerdoActual.map((acuerdo) => ({
        ...acuerdo,
        expanded: false,
      })),
      acuerdos: state.acuerdos.map((acuerdo) => ({
        ...acuerdo,
        expanded: false,
      })),
      historico: state.historico.map((acuerdo) => ({
        ...acuerdo,
        expanded: false,
      })),
    };
  }),

  on(cargarAcuerdosEditados, (state, { acuerdos, tipoAcuerdo }) => {
    return {
      ...state,
      acuerdos: tipoAcuerdo === 2 ? acuerdos : state.acuerdos,
      acuerdoActual: tipoAcuerdo === 1 ? acuerdos : state.acuerdoActual,
      tipoAcuerdo: tipoAcuerdo,
      historico: tipoAcuerdo === 3 ? acuerdos : state.historico,
    };
  }),

  on(loadResponsablesSuccess, (state, { nuevoAcuerdo }) => {
    return {
      ...state,
      nuevoAcuerdo: nuevoAcuerdo,
    };
  }),
  on(cancelarAcuerdoMRB, (state) => {
    return {
      ...state,
      nuevoAcuerdo: nuevoAcuerdo,
    };
  }),
  on(nuevoAcuerdoSuccess, (state) => {
    return {
      ...state,
      nuevoAcuerdo: { ...state.nuevoAcuerdo, show: false },
    };
  })
);
